import { Link } from 'react-router-dom';
import { LucideIcon } from 'lucide-react';

interface SidebarLinkProps {
  href: string;
  icon: LucideIcon;
  children: React.ReactNode;
  isActive?: boolean;
  isSidebarCollapsed: boolean;
  isExternal?: boolean;
  title?: string;
  dataAttribute?: string;
}

export function SidebarLink({
  href,
  icon: Icon,
  children,
  isActive = false,
  isSidebarCollapsed,
  isExternal = false,
  title,
  dataAttribute,
}: SidebarLinkProps) {
  const getClasses = () => {
    const baseClasses = `
      flex items-center px-3 py-2 text-sm rounded-lg
      ${isSidebarCollapsed ? 'justify-center px-0' : ''}
    `;

    if (isActive) {
      return `${baseClasses} bg-theme-light-bg dark:bg-theme-dark-bg text-[#E34290] dark:text-[#E34290]`;
    }

    return `${baseClasses} text-theme-light-text-secondary dark:text-theme-dark-text-secondary hover:bg-theme-light-bg dark:hover:bg-theme-dark-bg hover:text-[#E34290] dark:hover:text-[#E34290]`;
  };

  const getIconClasses = () => {
    const baseClasses = isSidebarCollapsed ? 'h-5 w-5' : 'h-4 w-4 mr-3';

    if (isActive) {
      return `${baseClasses} ${isSidebarCollapsed ? 'text-white' : 'text-[#E34290]'}`;
    }

    return baseClasses;
  };

  const linkProps = {
    className: getClasses(),
    title: isSidebarCollapsed ? title : undefined,
    ...(dataAttribute && { 'data-ph-capture-attribute': dataAttribute }),
  };

  const content = (
    <>
      <Icon className={getIconClasses()} />
      <span
        className={`${isSidebarCollapsed ? 'hidden' : ''} ${isExternal ? 'flex-1 text-left' : ''}`}
      >
        {children}
      </span>
    </>
  );

  if (isExternal) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" {...linkProps}>
        {content}
      </a>
    );
  }

  return (
    <Link to={href} {...linkProps}>
      {content}
    </Link>
  );
}
